<script lang="ts">
    import type { TCmsPageMarkets } from '$lib/services/losService/types';

    export let meta: {
        title: string;
        description: string;
        canonical: string;
        noIndex: boolean;
        seoSchema: any;
    };
    export let markets: TCmsPageMarkets;
</script>

<title>{meta.title}</title>
<meta name="description" content={meta.description} />
<link rel="canonical" href={meta.canonical} />
{#if meta.noIndex}
    <meta name="robots" content="noindex,nofollow" />
{/if}
{#if meta.seoSchema}
    {@html `<script type="application/ld+json">${meta.seoSchema}</script>`}
{/if}

{#if markets.alternateHrefs}
    {#each markets.alternateHrefs as market}
        <link rel="alternate" href={market.href} hrefLang={market.market} />
    {/each}
{/if}
{#if markets.defaultHref}
    <link rel="alternate" href={markets.defaultHref} hrefLang="x-default" />
{/if}

<meta name="twitter:card" content="summary_large_image" />
<meta name="twitter:description" content={meta.description} />
<meta name="twitter:title" content={meta.title} />
<meta name="twitter:site" content="@CasumoCasino" />
<meta
    name="twitter:image"
    content="https://www.casumo.com/los2assets/casumo-logo.daa56022fce3e4a9783787e246a73969.png"
/>
<meta name="twitter:creator" content="@CasumoCasino" />
<meta property="og:type" content="website" />
<meta property="og:title" content={meta.title} />
<meta property="og:description" content={meta.description} />
<meta property="og:url" content={meta.canonical} />
<meta property="og:site_name" content="Casumo" />
<meta
    property="og:image"
    content="https://www.casumo.com/los2assets/casumo-logo.daa56022fce3e4a9783787e246a73969.png"
/>
